export const AJAX = "AJAX";
export const INITIAL_PAGE_LOAD = "INITIAL_PAGE_LOAD";

export const makeAjaxAction = function (path, data, extraActionProps, httpMethod = "POST") {
  const csrfToken = document.querySelector("meta[name='csrf-token']").getAttribute("content");

  const options = {
    credentials: "same-origin",
    headers: {
      "X-Requested-With": "XMLHttpRequest",
      "X-CSRF-Token":     csrfToken,
      "Content-Type":     "application/json",
      "Accept":           "application/json"
    },
    method: httpMethod,
  };

  if (httpMethod === "POST") {
    options.body = JSON.stringify(data);
  }

  const action = {
    type: AJAX,
    path: path,
    options: options
  };

  return Object.assign(action, extraActionProps);
};
